module.exports = __webpack_public_path__ + "static/media/ban-khar-intro.e7dd0b1d.svg";